export const DEFAULT_TRAY_URL = 'http://localhost:8090'

export const normalizeTrayOpenURL = value => {
  const trimmed = String(value ?? '').trim()
  const candidate = trimmed || DEFAULT_TRAY_URL
  const withScheme = candidate.includes('://') ? candidate : `http://${candidate}`

  try {
    const parsed = new URL(withScheme)
    if (!['http:', 'https:'].includes(parsed.protocol) || !parsed.hostname || parsed.username || parsed.password) {
      return ''
    }

    if (parsed.pathname === '/' && !parsed.search && !parsed.hash) {
      return parsed.origin
    }
    return parsed.toString()
  } catch {
    return ''
  }
}
